import { combineReducers } from "redux";
import { isType } from "typescript-fsa";
import { login, reconnect, reconnectScheduled, session, } from "./actions";
const status = (state = 'logged-out', action) => {
    if (isType(action, login.started))
        return 'logging-in';
    if (isType(action, login.failed))
        return 'logged-out';
    if (isType(action, reconnect.started))
        return 'reconnecting';
    if (isType(action, reconnect.failed))
        return 'logged-out';
    if (isType(action, session.started))
        return 'logged-in';
    if (isType(action, session.done))
        return 'logged-out';
    return state;
};
const loginError = (state = null, action) => {
    if (isType(action, login.failed)) {
        if (action.payload.error.reason === 'Invalid credentials')
            return 'credentials';
        return 'unknown';
    }
    if (isType(action, login.started))
        return null;
    return state;
};
const logoutReason = (state = null, action) => {
    if (isType(action, login.started))
        return null;
    if (isType(action, reconnect.failed))
        return 'expired';
    if (isType(action, session.done))
        return action.payload.result;
    return state;
};
const reconnectAt = (state = null, action) => {
    if (isType(action, reconnectScheduled))
        return action.payload.reconnectAt;
    if (isType(action, reconnect.started))
        return null;
    return state;
};
/** @internal */
export default combineReducers({
    status,
    loginError,
    logoutReason,
    reconnectAt,
});



//////////////////
// WEBPACK FOOTER
// ./~/@neolab/ice-client/es/reducer.js
// module id = 314
// module chunks = 0